<div class="dialog__container">
  <div class="dialog__header">
    <span>{{ 'webPos.Storno' | translate }}</span>
  </div>

  <div class="dialog__content">
    <div class="return-payment-details">
      <div class="return-payment-details__row">
        <span class="return-payment-details__label">{{ 'webPos.PaymentType' | translate }}</span>
        <span class="return-payment-details__value">{{ data.payment?.PaymentType | paymentType }}</span>
      </div>

      <div class="return-payment-details__row">
        <span class="return-payment-details__label">{{ 'webPos.Date' | translate }}</span>
        <span class="return-payment-details__value">{{ data.payment?.PaidDate | localizedDateTime }}</span>
      </div>

      <div class="return-payment-details__row">
        <span class="return-payment-details__label">{{ 'webPos.Amount' | translate }}</span>
        <span class="return-payment-details__value">{{ data.payment?.Amount | hcurrency : data.payment?.Currency : true }}</span>
      </div>

      @if (availableCash !== null) {
        <div class="return-payment-details__row">
          <span class="return-payment-details__label">{{ 'webPos.AvailableCashInTender' | translate }}</span>
          <span class="return-payment-details__value" [class.return-payment-details__value--error]="cashInsufficient">
            {{ availableCash | hcurrency : data.payment?.Currency }}
          </span>
        </div>
        @if (cashInsufficient) {
          <div class="return-payment-details__error">
            {{ 'webPos.Errors.InsufficientCashInTender' | translate }}
          </div>
        }
      }

    </div>

    <form [formGroup]="form" class="return-payment-form">
      <div class="return-payment-form__field">
        <label class="return-payment-form__label">
          {{ 'webPos.Note' | translate }}
          <span class="return-payment-form__required">*</span>
        </label>
        <textarea
          formControlName="note"
          class="return-payment-form__textarea"
          placeholder="{{ 'webPos.ReasonNote' | translate }}"
          rows="3"
          maxlength="500"
          required>
        </textarea>
        <span class="return-payment-form__char-count">{{ form.get('note')?.value?.length || 0 }}/500</span>
      </div>
    </form>
  </div>

  <div class="dialog__footer">
    <div class="dialog__button-container">
      <app-action-button
        [buttonSize]="ActionButtonSize.Small"
        [buttonType]="ActionButtonType.Cancel"
        (clicked)="cancel()">
        {{ 'webPos.Cancel' | translate }}
      </app-action-button>
    </div>

    <div class="dialog__button-container">
      <app-action-button
        [buttonSize]="ActionButtonSize.Small"
        [buttonType]="ActionButtonType.Confirm"
        [disabled]="form.invalid || cashInsufficient"
        (clicked)="confirm()">
        {{ 'webPos.ToReturn' | translate }}
      </app-action-button>
    </div>
  </div>
</div>
